


















































































































































import { AdminPortalUser, idpStatusChange, RoleType, AdminUserStatus, UserPermission } from "@/shared/types";
import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";
import { Validator } from "vee-validate";
import { useUserStore } from "@/shared/store/user";

const dict = {
  custom: {
    Roles: {
      required: "User must have at least one role assigned."
    }
  }
};

@Component({ components: {} })
export default class EditAdminUser extends Vue {
  $validator: Validator;
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  employerRolePermissionStore = useEmployerRolePermissionStore();
  rolePermissionStore = useRolePermissionsStore();

  @Prop() userId?: number;
    roleOptions = this.employerRolePermissionStore.allRoles.map(x => {
    return { value: x.roleId, text: x.roleName };
  });
  adminUser = {
    userId: null,
    firstName: "",
    lastName: "",
    employeeId: "",
    username: "",
    email: "",
    phoneNumber: "",
    existingUserName: "",
    existingStatus: ""
  };
  selectedRoles: number[] = [];
  isEditable = false;
  isShowSaveChanges = false;
  isModalVisible = false;
  isShowEdit = true;
  isSubmitting = false;
  canRevokeAccess = true;
  isRevokeModalVisible = false;
  deactivateEligibleStatuses = [
    AdminUserStatus.Staged.toLowerCase(),
    AdminUserStatus.Provisioned.toLowerCase(),
    AdminUserStatus.Active.toLowerCase(),
    AdminUserStatus.LockedOut.toLowerCase(),
    AdminUserStatus.PasswordExpired.toLowerCase(),
    AdminUserStatus.Recovery.toLowerCase(),
    AdminUserStatus.Suspended.toLowerCase()
  ];
  resetPasswordEligibleStatuses = [
    AdminUserStatus.Active.toLowerCase(),
    AdminUserStatus.PasswordExpired.toLowerCase()
  ];
  get isRolePermissionsEnabled () {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions;
  }

  @Watch("userStore.adminPortalUsers")
  initializeModel () {
      const currentAdminUser = this.userStore.adminPortalUsers.filter(x => x.userId === this.userId).pop();
      this.setCurrentAdminUser(currentAdminUser);
  }

  mounted (): void {
    this.loadAdminUsersAndRoles();
  }
  onSubmit () {
  this.$validator.validate().then(valid => {
    if (valid) {
      this.isSubmitting = true;
      // call save action
      this.userStore.updateAdminUser({
        ... this.adminUser, email: this.adminUser.username, assignedRoles: this.selectedRoles
      })
      .then(resp => {
        if (resp) {
          // after the call succeeds route back to user management page
          this.loadAdminUsersAndRoles();
          this.initializeModel();
          this.onSaveChanges();
        }
        this.isSubmitting = false;
      });
    }
    });
  }
  onSync () {
    this.isSubmitting = true;
    // call sync action
    this.userStore.syncAdminUser(this.adminUser.userId)
        .then(resp => {
          if (resp) {
            this.onSaveChanges();
          }
          this.isSubmitting = false;
        });
  }

loadAdminUsersAndRoles () {
  this.employerRolePermissionStore.getRolesByType(RoleType.Admin);
  this.userStore.getAdminUsers();
}

closeModal () {
  this.isModalVisible = false;
}

showModal () {
  this.isModalVisible = true;
}

onCancel () {
    this.$router.push("/admin-users/admin-user-management");
}
onEdit () {
    this.isEditable = true;
    this.isShowSaveChanges = true;
    this.isShowEdit = false;
}

onSaveChanges () {
  this.isEditable = false;
  this.isShowSaveChanges = false;
  this.isShowEdit = true;
}

onActivateUser () {
  this.isSubmitting = true;
  this.userStore.activateAdminUser({
    userId: this.adminUser.userId,
    changeToStatus: idpStatusChange.Active,
    currentStatus: this.adminUser.existingStatus
  })
  .then(resp => {
      if (resp) {
        // after the call succeeds route back to user management page
        const adminuser = this.userStore.currentAdminPortalUser;
        this.setCurrentAdminUser(adminuser);
      }
      this.isSubmitting = false;
    });
}

onDeactivateUser () {
  this.isSubmitting = true;
  this.userStore.deactivateAdminUser({
    userId: this.adminUser.userId,
    changeToStatus: idpStatusChange.Deactivate,
    currentStatus: this.adminUser.existingStatus
  })
  .then(resp => {
    if (resp) {
    // after the call succeeds route back to user management page
       const adminuser = this.userStore.currentAdminPortalUser;
       this.setCurrentAdminUser(adminuser);
       this.closeModal();
       this.$router.push("/admin-users/admin-user-management");
    }
    this.isSubmitting = false;
  });
}

onRevokeUserAccess () {
  this.isSubmitting = true;
  this.userStore.revokeUserAccess(this.adminUser.userId)
  .then(resp => {
    if (resp) {
      // after the call succeeds route back to user management page
      this.isRevokeModalVisible = false;
      this.$router.push("/admin-users/admin-user-management");
    }
  })
  .finally(() => {
    this.isRevokeModalVisible = false;
    this.isSubmitting = false;
  });
}

onResetPasswordUser () {
  this.isSubmitting = true;
  this.userStore.resetPasswordAdminUser({
    userId: this.adminUser.userId,
    changeToStatus: idpStatusChange.ResetPassword,
    currentStatus: this.adminUser.existingStatus
  })
  .then(resp => {
    if (resp) {
      // after the call succeeds route back to user management page
      const adminuser = this.userStore.currentAdminPortalUser;
      this.setCurrentAdminUser(adminuser);
    }
    this.isSubmitting = false;
  });
}

onUnlock () {
  this.isSubmitting = true;
  this.userStore.unlockAdminUser({
    userId: this.adminUser.userId,
    changeToStatus: idpStatusChange.Unlock,
    currentStatus: this.adminUser.existingStatus
  })
  .then(resp => {
    if (resp) {
      // after the call succeeds route back to user management page
      const adminuser = this.userStore.currentAdminPortalUser;
      this.setCurrentAdminUser(adminuser);
    }
    this.isSubmitting = false;
  });
}

onResendActivationEmail () {
  this.isSubmitting = true;
  this.userStore.resendActivationEmail({
    userId: this.adminUser.userId,
    changeToStatus: idpStatusChange.ReSendActivationEmail,
    currentStatus: this.adminUser.existingStatus
  })
  .then(resp => {
      if (resp) {
        // after the call succeeds route back to user management page
        const adminuser = this.userStore.currentAdminPortalUser;
        this.setCurrentAdminUser(adminuser);
      }
      this.isSubmitting = false;
    });
}

get canEdit (): boolean {
  return this.isEditable;
}
get showSaveChanges (): boolean {
  return this.isShowSaveChanges;
}
get canActivateUser (): boolean {
  const isActivate = this.adminUser.existingStatus.toLowerCase() === AdminUserStatus.Deprovisioned.toLowerCase() ||
  this.adminUser.existingStatus === AdminUserStatus.Staged.toLowerCase();
  return isActivate;
}
get canDeactivateUser (): boolean {
  return this.deactivateEligibleStatuses.includes(this.adminUser.existingStatus.toLowerCase());
}
get canResetPassword (): boolean {
  return this.resetPasswordEligibleStatuses.includes(this.adminUser.existingStatus.toLowerCase());
}
get canResendActivationEmail (): boolean {
  const canResend = this.adminUser.existingStatus.toLowerCase() === AdminUserStatus.Provisioned.toLowerCase();
  return canResend;
}
get canUnlock (): boolean {
  return this.adminUser.existingStatus.toLowerCase() === AdminUserStatus.LockedOut.toLowerCase();
}

setCurrentAdminUser (currentAdminUser: AdminPortalUser) {
  this.adminUser.existingUserName = currentAdminUser.userName;
    this.adminUser.existingStatus = currentAdminUser.status;
    this.adminUser.userId = this.userId;
    this.adminUser.firstName = currentAdminUser.firstName;
    this.adminUser.lastName = currentAdminUser.lastName;
    this.adminUser.employeeId = currentAdminUser.employeeId;
    this.adminUser.username = currentAdminUser.userName;
    this.adminUser.email = currentAdminUser.email;
    this.adminUser.phoneNumber = currentAdminUser.phone;
    this.selectedRoles = currentAdminUser.roles.map(x => x.roleId );
}
  get showEdit (): boolean {
    return this.isShowEdit;
  }

  get isShowChangesDisabled (): boolean {
    return this.isSubmitting;
  }
  get hasEditPermission (): boolean {
    return this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalUserManagementEdit);
  }

}
